import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { backend } from '@shared/datastore/core';
import { userBalancesBackend } from './user-balances.backend';
// import { DatastoreBackendModule } from '@shared/datastore/core';
import { userBalancesReducer } from './user-balances.reducer';

// FIXME: remove that
backend.userBalances = userBalancesBackend;

@NgModule({
  imports: [
    StoreModule.forFeature('userBalances', userBalancesReducer),
    /* DatastoreBackendModule.forFeature(
      'userBalances',
      userBalancesBackend,
    ),*/
  ],
})
export class DatastoreUserBalancesModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/user-balances/user-balances.module.ts